import React from "react";
import styled from "@emotion/styled";
import { Link, Alert } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

const StyledAlert = styled(Alert)`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

interface SignupErrorAlertProps {
  error?: AxiosApiError | null;
}

export const SignupErrorAlert = (props: SignupErrorAlertProps) => {
  const { error } = props;

  const { t } = useTranslation();

  if (!error) return null;

  const customError = error?.response?.data?.errors?.[0];

  if (customError) {
    return (
      <StyledAlert severity="error" data-testid="signup-alert-error">
        {customError?.message}
      </StyledAlert>
    );
  }

  return (
    <StyledAlert severity="error" data-testid="something-wrong-message">
      <Trans
        i18nKey="signupPage.form.requestErrors.somethingWrongWithoutStatus"
        values={{ email: t("aboutCompany.support.email") }}
        components={{
          supportEmailLink: (
            <Link
              href={`mailto:${t("aboutCompany.support.email")}`}
              underline="hover"
            />
          ),
        }}
      />
    </StyledAlert>
  );
};
